import { render, staticRenderFns } from "./BusinessRulesTab.vue?vue&type=template&id=a513fca6&scoped=true&"
import script from "./BusinessRulesTab.vue?vue&type=script&lang=js&"
export * from "./BusinessRulesTab.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRulesTab.vue?vue&type=style&index=0&id=a513fca6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a513fca6",
  null
  
)

export default component.exports